export default __webpack_public_path__ + "static/media/9-1-1.0acb8973.png";